import {BaseEntity} from "./BaseEntity";

export class EmployeeWorkHours implements BaseEntity {
    constructor(
        public employeeId?:number,
        public employeeName?: string,
        public date?: string,
        public arrived?: string,
        public departed?: string,
        public hoursWorked?: number) {
    }
    parseJson(json: any): void {
        this.employeeId = json.employeeId;
        this.employeeName = json.employeeName;
        this.date = json.date;
        this.arrived = json.arrived;
        this.departed = json.departed;
        this.hoursWorked = json.hoursWorked;
    }
}
